"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DatabaseFieldCell;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RequiredAsterisk = _interopRequireDefault(require("../../RequiredAsterisk"));

function DatabaseFieldCell(props) {
  var value = props.value,
      required = props.row.required;
  return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_RequiredAsterisk["default"], {
    required: !!required
  }), value);
}

DatabaseFieldCell.propTypes = {
  value: _propTypes["default"].string.isRequired,
  row: _propTypes["default"].object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/ImportRecordsFlow/stepThree/databaseFieldCell.js
// module id = ctVP
// module chunks = 0